import React, { memo, useState } from 'react'
import classNames from 'classnames'
import NavigationItem from 'transfix-ui/components/NavigationItem'
import { makeStyles } from 'transfix-ui/core'
import { INavigationRoute } from '../types'

const NAVBAR_HEIGHT_PX = 48

interface IMenuProps {
  /**
   * @example [{ name: 'Home', location: 'home' }]
   */
  routes: INavigationRoute[]
  className?: string
}

const useMenuStyles = makeStyles({
  root: {
    height: NAVBAR_HEIGHT_PX,
    margin: 0,
    padding: 0,
  },
})

const Menu = memo<IMenuProps>(({ routes = [], className: classNameProp }) => {
  const [activeItem, setActiveItem] = useState<string>('')
  const classes = useMenuStyles()
  const className = classNames(classes.root, classNameProp)

  const toggleActiveItem = (name: string) => {
    setActiveItem(prev => (prev === name ? '' : name))
  }

  return (
    <ul data-test='Menu' className={className}>
      {routes.map(route => {
        const { name } = route || {}
        return (
          <NavigationItem
            route={route}
            key={route.name}
            onClick={toggleActiveItem}
            isOpen={activeItem === name}
          />
        )
      })}
    </ul>
  )
})

export default Menu
